<!-- 平台优惠管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent">
        <div class="ele-table-tool-default">
          <el-button size="small" type="primary" icon="el-icon-plus" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addPlatformDiscount">新建</el-button>
          <el-button size="small" type="primary" icon="el-icon-minus" :style="{backgroundColor: $store.state.deleteColor,borderColor: $store.state.deleteColor}" @click="delPlatformDiscount">删除</el-button>
        </div>
        <el-table
          @selection-change="handleSelectionChange"
          row-key="id"
          class="table"
          ref="tableData"
          :data="table.tableData"
          border
          :height="table.tableHeight"
          element-loading-text="拼命加载中,请等待"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column width="45" type="selection" :reserve-selection="true" align="center"></el-table-column>
          <el-table-column width="100" prop="id" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ (paging.page-1)*paging.size+scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.type == 1 ? "优惠政策":"退订政策" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shelves1" label="整租房源上架" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.shelves1 == 1 ? true:false" @change="changeGrounding($event,scope.row,1)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="shelves3" label="学生公寓上架" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.shelves3 == 1 ? true:false" @change="changeGrounding($event,scope.row,3)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="shelves2" label="短租房源上架" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.shelves2 == 1 ? true:false" @change="changeGrounding($event,scope.row,2)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="优惠政策标签" align="center">
            <template slot-scope="scope">
             <a :style="{background:scope.row.color.split(',')[0],color:scope.row.color.split(',')[1],borderRadius:'5px',display:'inline-block',padding:'0 2px'}">{{ scope.row.title }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="180" fixed="right">
            <template slot-scope="scope">
              <el-popconfirm class="real_pop" title="您确定要复制优惠政策信息吗？" @confirm="handleOperation('copy', scope.row)">
                <el-button slot="reference" type="text" size="mini" icon="el-icon-s-claim" :style="{color: $store.state.activeColor}">复制</el-button>
              </el-popconfirm>
              <el-button type="text" size="mini" @click="handleOperation('edit', scope.row)" icon="el-icon-edit" :style="{color: $store.state.activeColor,marginLeft:'10px'}">编辑</el-button>
              <el-popconfirm class="real_pop" title="您确定要删除优惠政策信息吗？" @confirm="handleOperation('remove', scope.row)">
                <el-button class="danger" slot="reference" type="text" size="mini" :icon="scope.row.status ? 'el-icon-circle-check':'el-icon-circle-close'">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tablePagination">
        <el-pagination
          class="customPagination"
          @size-change="handlePaginationChange"
          @current-change="handlePaginationCurrentChange"
          :current-page="paging.page"
          :page-sizes="[15, 25, 50]"
          :page-size="paging.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paging.total"
        >
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'PlatformDiscountManagement',
    data () {
      return {
        table: { // 表格参数
          tableData:[], // 表格数据
          tableHeight: null, // 表格高度
        },
        paging: { // 分页参数
          page: 1,// 页码
          size: 15, // 条数
          total: 0, // 总数
        },
        checkIds:[], // 所选列表
      }
    },
    methods: {
      // 获取表格数据
      getList(){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        },{
          "field":"houseId",
          "fun":"isNull"
        }];
        this.$api.findPreferential({
          page:this.paging.page,
          size:this.paging.size,
          parameter: JSON.stringify(parameter)
        }).then(res => {
          if (res.data.status == 200) {
            this.table.tableData = res.data.data.records;
            this.paging.total = Number(res.data.data.total);
            if(this.table.tableData != ""){
              this.$nextTick(() => {
                this.$refs.tableData.clearSelection();
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 分页部分改变条数
      handlePaginationChange(val) {
        this.paging.size = val;
        this.paging.page = 1;
        this.getList();
      },
      // 分页部分改变页码
      handlePaginationCurrentChange(val) {
        this.paging.page = val;
        this.getList();
      },
      // 切换选择
      handleSelectionChange(val) {
        this.checkIds = [];
        if (val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            this.checkIds.push(val[i].id);
          }
        }
      },
      // 新建PlatformDiscount
      addPlatformDiscount(){
        this.$router.push({
          path:'/PlatformDiscountManagementOperation',
        });
      },
      // 批量删除PlatformDiscount
      delPlatformDiscount(){
        for(let i = 0 ; i < this.table.tableData.length; i++){
          for(let j = 0; j < this.checkIds.length; j++){
            if (this.checkIds[j] == this.table.tableData[i].id){
              this.table.tableData[i].status = 0;
            }
          }
        }
        this.setBatch('批量删除成功！');
      },
      // 批量添加修改列表
      setBatch(title){
        this.$api.saveOrUpdatePreferentialBatch({ parameter: JSON.stringify(this.table.tableData)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 编辑/删除
      handleOperation(type,row){
        if (type == "edit") {  // 编辑操作
          this.$router.push({
            path:'/PlatformDiscountManagementOperation',
            query:{ data:row }
          });
        } else if (type == "remove") { // 删除操作
          for(let i = 0 ; i < this.table.tableData.length; i++){
            if (row.id == this.table.tableData[i].id){
              this.table.tableData[i].status = 0;
            }
          }
          this.setBatch('删除成功！');
        } else if (type == "copy") { // 复制操作
          delete row.id;
          this.$api.saveOrUpdatePreferential({parameter: JSON.stringify(row)}).then(res => {
            if (res.data.status == 200) {
              this.$message({
                type: 'success',
                message: '复制成功！'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        }
      },
      // 改变上架
      changeGrounding(id,data,type){
        let params = {};
        let grounding = id == true ? 1 : 0;
        if (type == 1){
          params = { id: data.id,shelves1:grounding };
        } else if (type == 2){
          params = { id: data.id,shelves2:grounding };
        } else if (type == 3){
          params = { id: data.id,shelves3:grounding };
        }
        this.$api.saveOrUpdatePreferential({parameter: JSON.stringify(params)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // table的高度
      getTableHeight(){
        let that = this;
        if($(".table").length > 0) {
          // 表格高度初始化事件
          $(".table").height(window.innerHeight - $(".table").offset().top - 70);
          $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
          that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
          // 窗口改变事件
          window.onresize = function () { // 定义窗口大小变更通知事件
            if($(".table").length > 0) {
              $(".table").height(window.innerHeight - $(".table").offset().top - 70);
              $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
              that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
            }
          };
        }
      },
    },
    mounted() {
      // 获取页面表格高度
      this.getTableHeight();
      // 获取列表
      this.getList();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/PlatformDiscountManagement.vue